export default __webpack_public_path__ + "static/media/elle5.90a44c15.webp";